export default __webpack_public_path__ + "static/media/surfmappers.2676804c.gif";